var DIRECTIONAL = {
    north: 'n',
    n: 'n',
    northeast: 'ne',
    ne: 'ne',
    east: 'e',
    e: 'e',
    southeast: 'se',
    se: 'se',
    south: 's',
    s: 's',
    southwest: 'sw',
    sw: 'sw',
    west: 'w',
    w: 'w',
    northwest: 'nw',
    nw: 'nw'
};


module.exports = DIRECTIONAL;
